import { NgModule, provideZoneChangeDetection } from '@angular/core';
import { provideHttpClientTesting } from '@angular/common/http/testing';
import { provideLocationMocks } from '@angular/common/testing';
import { ActivatedRoute, provideRouter } from '@angular/router';

import { TmsLibModule } from './tms-shared';
import { AuthService, MockAuthService } from './auth';

@NgModule({
  imports: [TmsLibModule],
  providers: [
    provideZoneChangeDetection(),
    provideRouter([]),
    provideLocationMocks(),
    provideHttpClientTesting(),
    { provide: AuthService, useClass: MockAuthService },
    {
      provide: ActivatedRoute,
      useValue: { snapshot: { paramMap: { get: () => '123' } } },
    },
  ],
})
export class BaseTestingModule {}
